import Vue from 'vue'
import Router from 'vue-router'

// 路由级按需加载。原来 41 个页面全部同步 import，首屏就要一次性下完
// 所有页面的 JS 和 CSS（app.css 曾经 1.1MB，其中 usdtmore 一个页就占 584KB）。
//
// 只留外层 Main 和首页 index 同步引入 —— 它们就是首屏，再拆一层只会多一个往返；
// 其余按业务分组，webpackChunkName 相同的会合并成一个 chunk，避免拆成几十个
// 小文件反而让弱网用户多付往返。
import Main from '@/components/Main'
import index from '@/components/mode/index'

// 底部导航：进站后最可能马上点的几个，合成一个包
const app = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/app')
const kefu = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/kefu')
const hongbao = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/hongbao')
const activity = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/activity')
const zhanzhu = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/zhanzhu')
const mine = () => import(/* webpackChunkName: "g-nav" */ '@/components/mode/mine')

// 登录单独成块：它是常见入口，不应该跟其他页面绑在一起等
const login = () => import(/* webpackChunkName: "g-login" */ '@/components/login')

// 游戏大厅 / 列表 / 试玩
const gamePage = () => import(/* webpackChunkName: "g-game" */ '@/components/mode/gamePage')
const gamelist = () => import(/* webpackChunkName: "g-game" */ '@/components/mode/gamelist')
const concise = () => import(/* webpackChunkName: "g-game" */ '@/components/mode/concise')

// 充值 / 提现 / 转账
const recharge = () => import(/* webpackChunkName: "g-pay" */ '@/components/recharge')
const rechargeResult = () => import(/* webpackChunkName: "g-pay" */ '@/components/rechargeResult')
const payInfo = () => import(/* webpackChunkName: "g-pay" */ '@/components/payInfo')
const withdrawal = () => import(/* webpackChunkName: "g-pay" */ '@/components/withdrawal')
const transfer = () => import(/* webpackChunkName: "g-pay" */ '@/components/transfer')
const money = () => import(/* webpackChunkName: "g-pay" */ '@/components/money')

// 账户资料 / 钱包 / 银行卡
const userInfo = () => import(/* webpackChunkName: "g-user" */ '@/components/userInfo')
const userCent = () => import(/* webpackChunkName: "g-user" */ '@/components/userCent')
const wallet = () => import(/* webpackChunkName: "g-user" */ '@/components/wallet')
const addUsdtCard = () => import(/* webpackChunkName: "g-user" */ '@/components/addUsdtCard')
const addAlipayCard = () => import(/* webpackChunkName: "g-user" */ '@/components/addAlipayCard')
const password = () => import(/* webpackChunkName: "g-user" */ '@/components/password')

// 各类记录 / 消息
const betRecord = () => import(/* webpackChunkName: "g-record" */ '@/components/betRecord')
const activityRecord = () => import(/* webpackChunkName: "g-record" */ '@/components/activityRecord')
const transRecord = () => import(/* webpackChunkName: "g-record" */ '@/components/transRecord')
const message = () => import(/* webpackChunkName: "g-record" */ '@/components/message')

// 优惠 / 活动 / 代理 / 赞助
const welfare = () => import(/* webpackChunkName: "g-promo" */ '@/components/welfare')
const fanshui = () => import(/* webpackChunkName: "g-promo" */ '@/components/fanshui')
const levelbonus = () => import(/* webpackChunkName: "g-promo" */ '@/components/levelbonus')
const birthdaybonus = () => import(/* webpackChunkName: "g-promo" */ '@/components/birthdaybonus')
const activityInfo = () => import(/* webpackChunkName: "g-promo" */ '@/components/activityInfo')
const applyagent = () => import(/* webpackChunkName: "g-promo" */ '@/components/applyagent')
const zhanzhuye = () => import(/* webpackChunkName: "g-promo" */ '@/components/zhanzhuye')
const boutBallBet = () => import(/* webpackChunkName: "g-promo" */ '@/components/boutBallBet')
const boutBallBetInfo = () => import(/* webpackChunkName: "g-promo" */ '@/components/boutBallBetInfo')
const findus = () => import(/* webpackChunkName: "g-promo" */ '@/components/mode/findus')

// 自带 130KB style，单独成块免得连累同组页面
const vip = () => import(/* webpackChunkName: "g-vip" */ '@/components/vip')

// 自带 584KB style（整份别站 CSS 被粘进了 scoped style），必须单独成块
const usdtmore = () => import(/* webpackChunkName: "g-usdtmore" */ '@/components/usdtmore')

Vue.use(Router)

export default new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/hongbao',
          name: 'hongbao',
          component: hongbao,

        },
        {
          path: '/activity',
          name: 'activity',
          component: activity, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/zhanzhu',
          name: 'zhanzhu',
          component: zhanzhu, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/mine',
          name: 'mine',
          component: mine, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }

        },
        {
          path: '/app',
          name: 'app',
          component: app, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }

        },

        {
          path: '/kefu',
          name: 'kefu',
          component: kefu,

        }
      ]
    }, {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,

    }, {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,
    }, {
      path: '/zhanzhuye',
      name: 'zhanzhuye',
      component: zhanzhuye,
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    }, {
      path: '/applyagent',
      name: 'applyagent',
      component: applyagent,


    }, {
      path: '/boutBallBet',
      name: 'boutBallBet',
      component: boutBallBet,
    }, {
      path: '/boutBallBetInfo',
      name: 'boutBallBetInfo',
      component: boutBallBetInfo,
    }, {
      path: '/message',
      name: 'message',
      component: message, meta: {
        requireAuth: true,
      }
    }, {
      path: '/fanshui',
      name: 'fanshui',
      component: fanshui, meta: {
        requireAuth: true,
      }
    }, {
      path: '/levelbonus',
      name: 'levelbonus',
      component: levelbonus, meta: {
        requireAuth: true,
      }
    }, {
      path: '/birthdaybonus',
      name: 'birthdaybonus',
      component: birthdaybonus, meta: {
        requireAuth: true,
      }
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/userCent',
      name: 'userCent',
      component: userCent,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addAlipayCard',
      name: 'addAlipayCard',
      component: addAlipayCard,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addUsdtCard',
      name: 'addUsdtCard',
      component: addUsdtCard,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/usdtmore',
      name: 'usdtmore',
      component: usdtmore,

    }, {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/welfare',
      name: 'welfare',
      component: welfare,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/betRecord',
      name: 'betRecord',
      component: betRecord,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/activityRecord',
      name: 'activityRecord',
      component: activityRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/transRecord',
      name: 'transRecord',
      component: transRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/money',
      name: 'money',
      component: money,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    }, {
      path: '/rechargeResult',
      name: 'rechargeResult',
      component: rechargeResult,
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,


    }, {
      path: '/concise',
      name: 'concise',
      component: concise,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    },
    {
      path: '/gamelist',
      name: 'gamelist',
      component: gamelist,
    },
    {
      path: '/findus',
      name: 'findus',
      component: findus,
    },

    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        requireAuth: true,

      }
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        requireAuth: true,

      }
    }
    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js